import db from '@/plugins/dexie';
import store from '../store';

/**
 * Nome da empresa, com cache no Dexie.
 *
 * A empresa nao entra no sync do WebSocket (nao esta em utils/ws/tabelas.js e a
 * API nao expoe um controller dela em all-agrocampo), entao a tabela local e a
 * unica fonte do nome quando o app abre sem conexao. Como a API sempre devolve
 * uma unica empresa, o cache e uma linha fixa (id 1), no mesmo padrao da tabela
 * `worker`.
 */
export default async function nomeEmpresa() {
  try {
    const [empresa] = await store.dispatch('empresa/find');

    await db.empresa.put({
      id: 1,
      empidnuvem: empresa.id,
      empidempresa: empresa.empidempresa,
      empnome: empresa.empnome,
      empdataatualizacao: empresa.empdataatualizacao,
    });

    return empresa.empnome;
  } catch (err) {
    console.log(err, 'empresa: sem resposta da API, usando cache local');
    return (await db.empresa.get(1))?.empnome ?? '';
  }
}
